import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React, { useMemo } from 'react'

import EmptyState from '@/components/EmptyState'
import { getDetailInfrastructureList } from '@/services/sez-regions'
import { ListBasicRequest } from '@/types/sez-regions'
import { useAppSelector } from '@/utils/hooks'

const Infrastructure: React.FC = () => {
  const { t } = useTranslation()
  const router = useRouter()
  const request: ListBasicRequest = useMemo(() => {
    return {
      params: { slug: String(router.query?.slug), skip: 0, limit: 1000 },
      headers: { 'Accept-Language': String(router.locale) },
    }
  }, [])

  const { data } = useAppSelector(getDetailInfrastructureList.select(request))

  return (
    <div className='container flex w-full flex-col gap-6 lg:gap-8'>
      {data && data.data.items.length > 0 ? (
        <>
          {data.data.items.map((item) => (
            <div
              className='flex flex-col gap-4'
              key={item.xid}
            >
              <h5 className='text-base font-bold leading-7 text-gray-1 lg:text-2xl lg:leading-8'>{item.title}</h5>
              <div className='grid grid-cols-1 gap-4 lg:grid-cols-4 lg:gap-[23px]'>
                {item.infrastructures.map((area) => (
                  <div
                    key={area.xid}
                    className='flex  rounded-lg border border-neutral-border px-3.5 py-3'
                  >
                    <div className='basis-[40px]'>
                      <img
                        src={area.icon.url}
                        alt=''
                      />
                    </div>

                    <div className='-ml-0.5 flex flex-1 flex-col gap-1'>
                      <small className='text-xs font-semibold text-gray-1'>{area.title}</small>
                      <small className='text-xs text-gray-2'>{area.description}</small>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </>
      ) : (
        <EmptyState
          title={String(t('common:emptyState.title'))}
          description={String(t('common:emptyState.description'))}
          contentWidth='lg:w-full'
        />
      )}
    </div>
  )
}

export default Infrastructure
